import bwipjs from 'bwip-js'
import alertService from './alert.service'
import imageService from './image.service'
import unsupportedPlaceholderImage from '../assets/label-barcode-unsupported-placeholder.png'
import placeholderImage from '../assets/label-barcode-placeholder.png'

const barcodeService = {
  generateBarcode (
    format: string,
    text: string,
    onReady?: (image: HTMLImageElement) => void
  ) {
    if (!format || !text) {
      imageService.generateImage(placeholderImage, onReady)
      return
    }
    const canvasElement = document.createElement('canvas')
    let canvas = null
    try {
      canvas = bwipjs.toCanvas(canvasElement, {
        bcid: format,
        text: text,
        includetext: true,
        scale: 5
      })
    } catch (error) {
      const message = 'This barcode format requires a specific format'
      alertService.info(message)
    }
    if (!canvas) {
      imageService.generateImage(unsupportedPlaceholderImage, onReady)
      return
    }
    const url = canvas.toDataURL('image/png')
    canvasElement.remove()
    return imageService.generateImage(url, onReady)
  }
}

export default barcodeService
